import { ValidationResult } from "../types";
export function savingsValidator(productOption, savingsFormat) {
    const result = new ValidationResult();
    let outSavingsFormat = savingsFormat;
    if (savingsFormat !== "hidden") {
        const hasSomeSavingsValue = productOption.choices.some((choice) => {
            return (choice.savingsPercent ?? 0) > 0 || (choice.savingsTotal ?? 0) > 0;
        });
        if (!hasSomeSavingsValue) {
            result.addValidation("None of the choices have savings data. savingsFormat will be 'hidden'.");
            outSavingsFormat === "hidden";
        }
        else {
            const hasSomeNegativeSavings = productOption.choices.some((choice) => {
                return (choice.savingsPercent ?? 0) < 0 || (choice.savingsTotal ?? 0) < 0;
            });
            if (hasSomeNegativeSavings) {
                result.addValidation("Some of choices have negative savings. This can be confusing the customer. savingsFormat will be 'hidden'");
                outSavingsFormat === "hidden";
            }
        }
    }
    return {
        messages: result.messages,
        savingsFormat: outSavingsFormat,
    };
}
//# sourceMappingURL=savings-validator.js.map